<script>
    import { appManager } from "../AppManagerStore";
    import { _ } from "svelte-i18n";
</script>

<section id="media" class="py-6 py-lg-8 bg-light">
    <div class="container">
        <div class="row align-items-center justify-content-between">
            <div class="col-12 col-md-6 col-lg-5 mb-6 mb-md-0">
                <span class="badge rounded-pill bg-success-soft mb-3">
                    <span class="h6 text-uppercase"
                        >{$_("communicate.media.tag")}</span>
                </span>

                <h2>
                    {$_("communicate.media.title1")} <br />
                    <span class="text-success"
                        >{$_("communicate.media.title2")}</span
                    >.
                </h2>
                <p class="fs-lg text-gray-700 mb-6">
                    {$_("communicate.media.content1")}
                </p>
                <p class="fs-lg text-gray-700 mb-6">
                    {$_("communicate.media.content2")}
                </p>

                <a href="#faqs" class="btn btn-success me-1 mt-3 lift">
                    {$_("communicate.media.get")}
                    <i class="fe fe-arrow-right ms-3" />
                </a>
            </div>
            <div class="col-12 col-md-6 d-none d-md-block">
                <div class="row">
                    <div class="text-center p-3">
                        <h1 class="display-3 fw-bold text-success">
                            <i class="fe fe-hash" /> 
                            {$_("communicate.media.stats.title")}
                        </h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 mt-8 me-n5">
                        <div class="text-center p-3">
                            <div class="city-title p-0">
                                {$_("communicate.media.stats.brussels.title")}</div>
                            <h1 class="display-3 fw-bold text-success mb-0">
                                <span class="">54</span>k
                            </h1>
                            <p class="text-body-secondary mb-6 mb-md-0">
                                {$_("communicate.media.stats.brussels.content")}
                            </p>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-center p-3">
                            <div class="city-title p-0">
                                {$_("communicate.media.stats.izegem.title")}</div>
                            <h1 class="display-3 fw-bold text-success mb-0">
                                <span class="">8</span>k
                            </h1>
                            <p class="text-body-secondary mb-6 mb-md-0">
                                {$_("communicate.media.stats.izegem.content")}
                            </p>
                        </div>
                        <div class="text-center p-3">
                            <div class="city-title p-0">
                                {$_("communicate.media.stats.mechelen.title")}</div>
                            <h1 class="display-3 fw-bold text-success mb-0">
                                <span class="">40</span>k
                            </h1>
                            <p class="text-body-secondary mb-6 mb-md-0">
                                {$_("communicate.media.stats.mechelen.content")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .city-title {
        font-size: 1.5rem;
    }
</style>